export default (d) => typeof d === 'function' ? d : () => d;
